import React, { useState } from 'react';
import axios from 'axios';
import { ShieldCheck, Loader2 } from 'lucide-react';
import { API } from '../../config';

export const AgeConfirmModal = ({ onConfirmed }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const confirm = async () => {
    setBusy(true);
    setError('');
    try {
      await axios.post(`${API}/auth/confirm-age`);
      onConfirmed();
    } catch {
      setError('Errore di connessione. Riprova.');
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/85 backdrop-blur-sm p-6" data-testid="age-confirm-overlay">
      <div className="w-full max-w-sm bg-[#1F1F1F] rounded-3xl border border-[#F5A623]/30 p-7 text-center" data-testid="age-confirm-modal">
        <div className="w-16 h-16 rounded-full bg-[#F5A623]/15 border border-[#F5A623]/40 flex items-center justify-center mx-auto mb-5">
          <ShieldCheck className="w-8 h-8 text-[#F5A623]" />
        </div>
        <p className="text-lg font-bold text-white mb-6" data-testid="age-confirm-text">Confermo di avere almeno 18 anni</p>
        {error && <p className="text-xs text-red-400 mb-3" data-testid="age-confirm-error">{error}</p>}
        <button
          onClick={confirm}
          disabled={busy}
          className="w-full h-14 btn-primary rounded-2xl font-bold flex items-center justify-center disabled:opacity-60"
          data-testid="age-confirm-btn"
        >
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Confermo'}
        </button>
      </div>
    </div>
  );
};

export default AgeConfirmModal;
